import styled from 'styled-components'

import { DownTrendIcon, UpTrendIcon, ArrowRightIcon } from '@root/shared/ui-kit'

import { TrendColor } from './TrendColor'

import type { TrendColorProps } from './TrendColor'
import type { Trend } from '../model'
import type { ClassNameProps } from '@root/shared/react'
import type { IconProps } from '@root/shared/ui-kit'

type Props = IconProps & TrendColorProps & ClassNameProps

const trendToIcon: Record<Trend.Trend, React.FC<IconProps>> = {
  down: DownTrendIcon,
  neutral: ArrowRightIcon,
  up: UpTrendIcon,
}

export const TrendIcon: React.FC<Props> = ({
  trend,
  variant = 'bright',
  className,
  ...iconProps
}) => {
  const Component = trendToIcon[trend]

  return (
    <Root trend={trend} variant={variant} className={className}>
      <Component {...iconProps} />
    </Root>
  )
}

const Root = styled(TrendColor)`
  display: inline-flex;
`
